import {useTranslation} from 'react-i18next';
import {enUS, nlNL} from '@mui/material/locale';
import {nlNL as nlnl, enUS as enus} from '@mui/x-data-grid';
import {useEffect, useState} from 'react';
// ----------------------------------------------------------------------

const LANGS = [
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    tableValue: enus,
    icon: 'enflag'
  },
  {
    label: 'Dutch',
    value: 'nl',
    systemValue: nlNL,
    tableValue: nlnl,
    icon: 'nlflag'
  }
];

export default function useLocales() {
  const {i18n, t: translate} = useTranslation();
  const langStorage = localStorage.getItem('i18nextLng');
  const language = window.navigator.language;
  const languageValue = language.split('-')[0];
  const [currentLang, setCurrentLang] = useState(
    LANGS.find(_lang => _lang.value === langStorage) ||
      (languageValue === 'nl' ? LANGS[1] : LANGS[0])
  );

  useEffect(() => {
    const storedLang = localStorage.getItem('i18nextLng');
    const foundLang =
      LANGS.find(_lang => _lang.value === storedLang) ||
      (languageValue === 'nl' ? LANGS[1] : LANGS[0]);
    setCurrentLang(foundLang);
  }, [langStorage]);

  const handleChangeLanguage = (newLang: string) => {
    i18n.changeLanguage(newLang);
    setCurrentLang(
      LANGS.find(lang => lang.value === newLang) ||
        (languageValue === 'nl' ? LANGS[1] : LANGS[0])
    );
  };

  return {
    onChangeLang: handleChangeLanguage,
    translate,
    currentLang,
    allLang: LANGS
  };
}
